module.exports = __webpack_public_path__ + "img/icon-score3.48bd5d89.svg";